/**
 * 签收中心请求
 */
import request from '@/utils/http';
const otpBaseUrl = '/api-antms/receipt';
// const otpBaseUrl = '';

// 签收中心列表
export const getReceiptSignList = data => {
    return request({
        url: `/api-antms/query/lsp/receipt/queryReceipt`,
        method: 'post',
        data
    });
};

// 签收中心-列表分页统计数量
export const queryCount = data => {
    return request({
        url: `/api-antms/query/lsp/receipt/queryCount`,
        method: 'post',
        data
    });
};

// 获取阿波罗配置的最大查询时间区间
export const queryTimeInterval = data => {
    return request({
        url: `/api-antms/query/page/queryTimeInterval`,
        method: 'post',
        data
    });
};

// 签收中心查看详情
export const getReceiptSignDetailInfo = data => {
    return request({
        url: `${otpBaseUrl}/receipt/queryReceiptByTaskNo`,
        method: 'get',
        params: data
    });
};

// 签收中心详情-签收明细
export const getReceiptDetail = data => {
    return request({
        url: `${otpBaseUrl}/receipt/queryReceiptDetail`,
        method: 'post',
        data
    });
};

// 签收中心-根据TK单查询接口
export const queryReceiptDetailByTaskNo = data => {
    return request({
        url: `${otpBaseUrl}/receipt/queryReceiptDetailByTaskNo`,
        method: 'get',
        params: data
    });
};

// 签收中心-逾期明细查询
export const getReceiptOverdueDetail = data => {
    return request({
        url: `${otpBaseUrl}/receipt/queryReceiptOverdueByTaskNo`,
        method: 'post',
        data
    });
};

// 签收中心-签收
export const receiptSign = data => {
    return request({
        url: `${otpBaseUrl}/receipt/receiptSign`,
        method: 'post',
        data
    });
};

// 签收中心-拒收
export const receiptRejectSign = data => {
    return request({
        url: `${otpBaseUrl}/receipt/receiptReject`,
        method: 'post',
        data
    });
};

// 签收中心-签改拒
export const receiptChangeReject = data => {
    return request({
        url: `${otpBaseUrl}/receipt/receiptChangeReject`,
        method: 'post',
        data
    });
};

// 签收中心-拒收
export const receiptOverdue = data => {
    return request({
        url: `${otpBaseUrl}/receipt/overdue`,
        method: 'post',
        data
    });
};

// 签收中心详情 - 附件明细
export const getAttachmentDetail = data => {
    return request({
        url: `/api-antms/transport/attachment/list`,
        method: 'get',
        params: data
    });
};

// 签收中心-回单上传接口
export const uploadReceipt = data => {
    return request({
        url: `${otpBaseUrl}/receipt/upload`,
        method: 'post',
        data
    });
};

// 签收中心-回单删除通用接口
export const deletePicture = data => {
    return request({
        url: `${otpBaseUrl}/receipt/deletePicture`,
        method: 'post',
        data
    });
};

// 签收中心-回单批量删除通用接口
export const deletePictureByIds = data => {
    return request({
        url: `${otpBaseUrl}/receipt/deletePictureByIds`,
        method: 'post',
        data
    });
};

// 签收中心-异常审批
export const exceptionFlow = data => {
    return request({
        url: `${otpBaseUrl}/receipt/exceptionflowStart`,
        method: 'post',
        data
    });
};

// 签收中心-重推
export const signPush = data => {
    return request({
        url: `${otpBaseUrl}/receipt/ofcSignRePush`,
        method: 'post',
        data
    });
};

// 签收中心-上楼佐证上传
export const receiptCvteUpload = data => {
    return request({
        url: `${otpBaseUrl}/receipt/receiptCvteUpload`,
        method: 'post',
        data
    });
};

// 苏宁订单查看采购入库详情
export const getSuNingDataApi = (params) => {
    return request({
        url: `${otpBaseUrl}/receipt/querySuNingReceiptDetail/${params}`,
        method: 'get'
    });
};

// 批量查看附件
export const batchAttachmentPreview = data => {
    return request({
        url: `${otpBaseUrl}/receipt/batchAttachmentPreview`,
        method: 'post',
        data
    });
};

// 签收中心-用户签收详情
export const getUserReceiptDetail = (data) => {
    return request({
        url: `${otpBaseUrl}/receipt/queryUserReceiptDetailByTaskNo`,
        method: 'get',
        params: data
    });
};

// 签收中心-网点签收详情
export const getLastmileReceiptDetail = (data) => {
    return request({
        url: `${otpBaseUrl}/receipt/queryLastmileReceiptDetailByOrderNo`,
        method: 'get',
        params: data
    });
};

// 入库数据
export const queryWarehouseData = data => {
    return request({
        url: `${otpBaseUrl}/receipt/queryOfcByCustomerOrderNo`,
        method: 'get',
        params: data
    });
};

// 签收中心-增值费修改
export const updateCharge = data => {
    return request({
        url: `${otpBaseUrl}/receipt/updateCharge`,
        method: 'post',
        data
    });
};

// 签收中心-批量删除附件
export const deletePictureBatch = data => {
    return request({
        url: `${otpBaseUrl}/receipt/deletePictureBatch`,
        method: 'post',
        data
    });
};

// 违规卸货图片删除接口
export const illegalUnloadPicDelete = data => {
    return request({
        url: `${otpBaseUrl}/receipt/illegalUnloadPicDelete`,
        method: 'post',
        data
    });
};

// 违规卸货图片上传接口
export const illegalUnloadPicUpload = data => {
    return request({
        url: `${otpBaseUrl}/receipt/illegalUnloadPicUpload`,
        method: 'post',
        data
    });
};

// 违规卸货字段更新接口
export const illegalUnloadUpdate = data => {
    return request({
        url: `${otpBaseUrl}/receipt/illegalUnloadUpdate`,
        method: 'post',
        data
    });
};

// 签收中心-预签收保存
export const predictSign = data => {
    return request({
        url: `/api-antms/receipt/lsp/sign/predictSign`,
        method: 'post',
        data
    });
};

// 签收中心-预签收日志
export const getLogDataList = data => {
    return request({
        url: `/api-antms/receipt/lsp/sign/querySignLog`,
        method: 'post',
        data
    });
};
